/*
  OliveDrab PDP colour row

  The server renders the colours it can see from the collections this piece
  sits in, which is only their first page. This asks the shop's own search
  for the style key as well, and merges in any colour that was missed, so a
  family split across collections still shows up whole.

  Nothing here invents a colour: a piece is only added when its title, with
  the colour words taken out, is the same style key as this one.

  Designed by Thriftizer.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-od-colours]');
  if (!root) return;

  var grid = root.querySelector('[data-od-colours-grid]');
  if (!grid) return;

  var key = (root.dataset.key || '').trim();
  var max = parseInt(root.dataset.max, 10) || 12;
  var here = root.dataset.productId;
  function bag(s) {
    var o = {};
    (s || '').toLowerCase().split(/[,\s]+/).forEach(function (w) { if (w) o[w] = true; });
    return o;
  }

  var colourWords = bag(root.dataset.words);
  var skipWords = bag(root.dataset.skip);

  if (!key) return;

  // the same rule as od-style-key.liquid: whole words only, so "in" cannot
  // cut the middle out of "linen" and pull every linen piece into the family
  function styleKey(title) {
    var colour = '';
    var kept = [];
    (title || '').toLowerCase().replace(/[,\-&/]/g, ' ').split(/\s+/).forEach(function (w) {
      if (!w) return;
      if (colourWords[w]) { if (!colour) colour = w; return; }
      if (skipWords[w]) return;
      kept.push(w);
    });
    return { key: kept.join(' '), colour: colour };
  }

  function titleCase(s) {
    return s.replace(/(^|\s)([a-z])/g, function (m, a, b) {
      return a + b.toUpperCase();
    });
  }

  function have() {
    var ids = {};
    grid.querySelectorAll('[data-od-colour]').forEach(function (el) {
      ids[el.dataset.productId] = true;
    });
    return ids;
  }

  function chip(p, colour) {
    var a = document.createElement('a');
    a.className = 'od-colour';
    if (String(p.id) === String(here)) a.className += ' od-colour--now';
    if (p.available === false) a.className += ' od-colour--out';
    a.href = p.url;
    a.setAttribute('role', 'listitem');
    a.setAttribute('data-od-colour', '');
    a.dataset.productId = p.id;
    var name = colour ? titleCase(colour) : p.title;
    a.dataset.colour = name;
    a.title = p.title;

    var span = document.createElement('span');
    span.className = 'od-media od-media--portrait od-colour__media';
    if (p.featured_image || p.image) {
      var img = document.createElement('img');
      img.src = (p.featured_image || p.image);
      img.alt = p.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      span.appendChild(img);
    }
    a.appendChild(span);

    var label = document.createElement('span');
    label.className = 'od-colour__name';
    label.textContent = name;
    a.appendChild(label);
    return a;
  }

  var url = '/search/suggest.json?q=' + encodeURIComponent(key) +
    '&resources[type]=product&resources[limit]=10' +
    '&resources[options][unavailable_products]=last';

  fetch(url, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var list = data && data.resources && data.resources.results &&
        data.resources.results.products;
      if (!list || !list.length) return;

      var seen = have();
      var added = 0;
      var room = max - grid.querySelectorAll('[data-od-colour]').length;

      list.forEach(function (p) {
        if (added >= room) return;
        if (seen[p.id]) return;
        var k = styleKey(p.title);
        if (!k.key || k.key !== key) return;
        seen[p.id] = true;
        grid.appendChild(chip(p, k.colour));
        added++;
      });

      if (grid.querySelectorAll('[data-od-colour]').length > 1) {
        root.hidden = false;
      }
    })
    .catch(function () { /* the server-rendered colours stand on their own */ });
})();
